<template lang="pug">
    .equal-columns.checkout-page-columns
        .column.left
            perfect-scrollbar
                slot(name="header")
                .main-menu
                    slot(name="menu")
                main.contentpage
                    Authenticate(defaultTab="signin" :registration="false")
                        .section(v-if="mainSections.length" v-for="(section, index) in mainSections" :key="section.id" :class="section.key")
                            Heading(v-if="section.key === 'heading'" :section="section")
                            Post(v-if="section.key === 'post'" :section="section")
                            Checkout(v-if="section.key === 'checkout'" :section="section")
        .column.right
            perfect-scrollbar
                main.addition
                    .section(v-if="additionalSections.length" v-for="(section, index) in additionalSections" :key="section.id" :class="section.key")
                        Post(v-if="section.key === 'post'" :section="section")
                slot(name="footer")
</template>
<script>

import { mapGetters, mapActions } from 'vuex'

import Authenticate from '@/components/Authenticate'
import Post from '@/components/Post'
import Heading from '@/components/Heading'
import Checkout from '@/extensions/shop/components/Checkout'

export default {
    name: "CheckoutPage",

    components: {
        Post,
        Heading,
        Authenticate,
        Checkout,
    },
    computed: {
        mainSections() {
            return this.sections.filter(section => {
                return section.area === 'main' && (section.key === 'heading' || section.key === 'post' || section.key === 'checkout')
            })
        },
        additionalSections() {
            return this.sections.filter(section => {
                return section.area === 'terms' && section.key === 'post'
            })
        },
        ...mapGetters({
            sections: 'currentPage/sections',
            parent: 'currentPage/parent',
            menus: 'menus',
        }),
    }
}
</script>
<style lang="sass" scoped>
    .section
        margin: 25px 0
    .column.right
        .addition
            padding-bottom: 75px
        &::after
            content: ""
            position: absolute
            display: block
            width: 100%
            bottom: 0
            height: 100px
            pointer-events: none
            background: rgb(2,0,36)
            background: linear-gradient(180deg, rgba(2,0,36,0) 0%, rgba(255,255,255,1) 40%)
</style>
